module.exports = __webpack_public_path__ + "img/3.87fe46b0.png";